import guestlistModelReducer from '../../../../../pages/guestlists/helpers/guestlist-model-reducer';

export default class AlGuestlistProtectedFilesController {

    constructor($scope, $injector, $element) {
        this.scope = $scope;
        this.injector = $injector;
        this.element = $element;

        this.api = this.injector.get('$http');
        this.alert = this.injector.get('Alert');

        this.guestlist = null;
        this.mediaDirectoryUuid = _.get(this.injector.get('Users'), 'state.company.media.default_directories.guestlists', null);
        this.fileUploadInProgress = false;

        this.downloads = [];
        this.loading = true;
        this.selectedFileTrigger = null;

        this.sortDirections = [
            {
                key: 'asc',
                name: 'A-Z'
            },
            {
                key: 'desc',
                name: 'Z-A'
            }
        ];

        this.sortFields = [
            {
                field: 'file.file_name',
                name: 'sort by name'
            },
            {
                field: 'file.size',
                name: 'sort by file size'
            },
            {
                field: 'file.created_at',
                name: 'sort by upload time'
            }
        ];
    }

    $onInit() {
        this.localStorageKey = `AlGuestlist${this.guestlist.id}DownloadsFastPipeConfig`;
        this._initFastPipeConfiguration();

        this.refreshDownloads();
        this._initWatchers();
    }

    refreshDownloads() {
        this.loading = true;
        localStorage.setItem(this.localStorageKey, JSON.stringify(this.fastPipeConfiguration));
        this._loadDownloads();
    }

    _loadDownloads() {
        const sort = {};

        sort[this.fastPipeConfiguration.sortField] = this.fastPipeConfiguration.sortDirection;

        this.api
            .post(
                `fp/guestlists/${this.guestlist.id}/downloads`,
                {
                    fields: [
                        'id',
                        'file.file_name',
                        'file.size',
                        'file.links',
                        'file.created_at',
                        'file.mime',
                        'file.uuid',
                        'file.type'
                    ],
                    pagination: {
                        perPage: -1
                    },
                    sort,
                    keyword: this.fastPipeConfiguration.keyword
                }
            )
            .then(({data}) => {
                this.loading = false;
                this.downloads = data.data;
            })
    }

    updateFastPipeConfigurationField(field, newValue) {
        _.set(this.fastPipeConfiguration, field, newValue);
        this.refreshDownloads();
    }

    removeDownload(download) {
        this._getGuestlistModel()
            .then((glModel) => {
                glModel.downloads = _.filter(glModel.downloads, (curDownload) => {
                   return curDownload.file_uuid !== download.file.uuid;
                });

                this._putGuestlistModel(glModel)
                    .then(() => {
                        this.alert.info('Success', 'Download removed');
                        this.refreshDownloads();
                    })
                    .catch(() => {
                        this.alert.error('Error', 'Error while removing download. Please retry');
                        this.refreshDownloads();
                    })
            })
    }

    _initFastPipeConfiguration() {
        let config = {
            sortField: 'file.file_name',
            sortDirection: 'asc',
            keyword: ''
        };

        const localStorageContents = localStorage.getItem(this.localStorageKey);
        try {
            config = _.defaults(JSON.parse(localStorageContents), config);
        } catch (e) {
        }

        this.fastPipeConfiguration = config;
    }

    _getGuestlistModel() {
        return this.api.get(`guestlists/${this.guestlist.id}`)
            .then(({data}) => {
                return guestlistModelReducer(data.data);
            })
    }

    _putGuestlistModel(newModel) {
        return this.api.put(`guestlists/${this.guestlist.id}`, newModel);
    }

    _initWatchers() {
        this.scope.$watch(
            () => this.selectedFileTrigger,
            () => {
                if (this.selectedFileTrigger) {
                    this.fileUploadInProgress = true;
                    const newFileUuid = this.selectedFileTrigger;
                    this.selectedFileTrigger = null;

                    this._getGuestlistModel()
                        .then((glModel) => {
                            glModel.downloads.push({
                                file_uuid: newFileUuid
                            })

                            this._putGuestlistModel(glModel)
                                .then(() => {
                                    this.alert.success('Success', 'Download added');
                                    this.refreshDownloads();
                                })
                                .catch(() => {
                                    this.alert.error('Error', 'Adding download failed. Please try again');
                                    this.refreshDownloads();
                                });
                        });

                    this.injector.get('$timeout')(() => {
                        this.fileUploadInProgress = false;
                    }, 0);
                }
            });
    }
}

AlGuestlistProtectedFilesController.$inject = [
    '$scope',
    '$injector',
    '$element'
];



// WEBPACK FOOTER //
// ./src/app/modules/guestlists/components/al-guestlist-protected-files/controllers/component.js